import type React from "react"
import { useState, useEffect } from "react"
import { Box, CircularProgress, Typography, useTheme } from "@mui/material"
import { CloseButton, ModalContent, StyledModal } from "./TaskDetailEdit/TaskDetailsDropdownModal"
import CommonButton from "./CommonButton"
import { useTimerContext } from "../contexts/TimerContext"
import LocalStorageUtil from "../utils/localStorageUtil"
import { storageKeys } from "../utils/constants"
import useResponsive from "../hooks/useResponsive"
import apiService from "../apiService/ApiService"
import { AxiosResponse, SaveWorkerHoursLogging } from "../utils/urlConst"
import { useAlert } from "../contexts/AlertContext"
import { useNavigate } from "react-router-dom"
import { t } from "i18next"

const ForegroundPopup: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false)
    const theme = useTheme();
    const {
        setIsTimerOn,
        setSelectedProjectForLog,
        selectedProjectForLog,
        setStartTime,
        isTimerOn
    } = useTimerContext();
    const { isMobile } = useResponsive();
    const { showAlert } = useAlert();
    // const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const checkTimeAndShowPopup = () => {
        const isAuthenticated = LocalStorageUtil.getItem(storageKeys.isAuthenticated, false);
        if (isAuthenticated) {
            const currentTime = new Date()
            const currentHour = currentTime.getHours()
            // const lastShownTime = LocalStorageUtil.getItem(storageKeys.lastPopupTime, null)
            // if (currentHour >= 9 && (!lastShownTime || new Date(lastShownTime).getDate() !== currentTime.getDate())) {
            console.log("checkTimeAndShowPopup isTimerOn", isTimerOn)
            if (currentHour >= 21 && isTimerOn) {
                setIsVisible(true)
                LocalStorageUtil.setItem(storageKeys.lastPopupTime, currentTime.toISOString())
            }
        }
    }


    useEffect(() => {
        // Check time when the component mounts
        checkTimeAndShowPopup()

        // Add event listener for when the app comes to foreground
        const handleVisibilityChange = () => {
            if (!document.hidden) {
                checkTimeAndShowPopup()
            }
        }

        document.addEventListener("visibilitychange", handleVisibilityChange)

        // Cleanup
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange)
        }
    }, [isTimerOn])

    const handleClose = () => {
        setIsVisible(false)
    }
    const handleTimer = () => {
        const projectId = selectedProjectForLog?.id ?? 0
        const now = new Date()
        const endTime = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`
        setIsTimerOn(false)
        setStartTime(0)
        saveProjectLogToServer(projectId, null, endTime)
            .finally(() => {
                setSelectedProjectForLog({
                    id: null,
                    name: null,
                })
                setIsVisible(false)
            }
            )
    }

    // fetch ProjectList api call
    const saveProjectLogToServer = async (projectId: number, startTime: string | null, endTime: string | null) => {
        try {
            setIsLoading(true)
            let userToken = LocalStorageUtil.getItem(storageKeys.authToken, "");
            let userId = LocalStorageUtil.getItem(storageKeys.userId, "");
            let medwerkerId = LocalStorageUtil.getItem(storageKeys.workerId, "");

            let jsondata = JSON.stringify({
                token: userToken,
                user_id: userId,
                medewerker_id: medwerkerId,
                project_id: projectId,
                start_time: startTime,
                end_time: endTime,
            });

            apiService.setAuthToken(userToken);
            const responseJson: AxiosResponse | null = await apiService.post(SaveWorkerHoursLogging, jsondata);
            if (responseJson?.hasOwnProperty('status') && responseJson?.status_code === 1) {
                console.log(" saveProjectLogToServer responseJson", responseJson)
                // showAlert("Log Saved Succesfully", "success")
                showAlert(startTime ? t("timer.projectStarted") : t("timer.projectLogged"), "success")
            } else {
                showAlert(t("common.server_error"), 'error')
                setIsLoading(false);
            }
        } catch (error) {
            showAlert(t("common.server_error"), 'error')
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <StyledModal
            open={isVisible}
            onClose={handleTimer}
            aria-labelledby="custom-alert-modal"
            aria-describedby="custom-alert-description"
        >
            <ModalContent maxWidth={isMobile ? 350 : isTimerOn ? 500 : 400} >
                <CloseButton
                    aria-label="close"
                    onClick={handleTimer}
                    sx={{ color: "text.secondary" }}
                >
                    <img
                        src={"/assets/ic_alert_close.svg"}
                        alt={`close-icon`}
                        width="16px"
                        height="16px"
                    />
                </CloseButton>

                <Box my={4} sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                    <Typography sx={{
                        fontFamily: "Nunito Sans Regular500",
                        fontSize: "18px",
                        p: 1,
                        mb: 2,
                        color: theme.palette.blueColors.main
                    }}>Your Timer is going to off for Today!</Typography>

                </Box>

                <Box my={2} display="flex" justifyContent="center">
                    {isLoading ?
                        <CircularProgress />
                        :
                        <CommonButton
                            translationKey={"common.label_ok"}
                            onClick={handleTimer}
                            fullWidth={false}
                            sx={{
                                fontFamily: "Nunito Sans Regular500",
                                fontWeight: 700,
                                backgroundColor: "primary.main",
                                color: theme.palette.secondary.main,
                            }}

                        />}
                </Box>
            </ModalContent>
        </StyledModal>
    )
}

export default ForegroundPopup

